import Close from "@/assets/icons/Close";
import InfoLine from "@/assets/icons/InfoLine";
import AppButton from "@/components/shared/AppButton";
import { Modal, ModalBackdrop, ModalBody, ModalCloseButton, ModalContent } from "@/components/ui/modal";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { useT } from "@transifex/react";

interface ShowAddressModalProps {
  isOpen: boolean;
  onClose: () => void;
  locationName: string;
  locationAddress: string;
}

const ShowAddressModal: React.FC<ShowAddressModalProps> = ({ isOpen, onClose, locationName, locationAddress }) => {
  const t = useT();
  return (
    <Modal isOpen={isOpen} size="lg">
      <ModalBackdrop />
      <ModalContent className="bg-background-100 max-w-md mx-auto rounded-[16px] p-0 pt-[32px] flex flex-col justify-center">
        <ModalCloseButton onPress={onClose} className="absolute top-4 right-4 z-10" data-test-id="close-button">
          <Close height={26} fill="text-typography-900" width={26} />
        </ModalCloseButton>
        <ModalBody className="m-0 p-0">
          <VStack className="gap-[32px]">
            <VStack className="gap-[16px] items-center px-[20px]">
              <InfoLine stroke="bg-typography-900" fill="none" height={25} width={25} />
              <Text className="font-[700] text-[18px] text-center text-typography-900">{t("Location Details")}</Text>
              <Text className="font-[600] leading-[22px] text-[16px] text-center text-typography-900">
                {locationName}
                {"\n"}
                <Text className="font-[400] leading-[22px] text-[16px] text-center text-typography-900">{locationAddress}</Text>
              </Text>
            </VStack>
            <VStack className="border-t p-[20px] border-outline-300">
              <AppButton onPress={onClose} title={t("Close")} />
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ShowAddressModal;
